import { Module } from "@nestjs/common";
import { AppController } from "./app.controller";
import { AppService } from "./app.service";
import { FactoriesModule } from "./factories/factories.module";
import { UsersModule } from "./users/users.module";
import { TypeOrmModule } from "@nestjs/typeorm";
import { AuthModule } from "./auth/auth.module";
import { JwtModule } from "@nestjs/jwt";
import { appConfig } from "../../config";
import { ScheduleModule } from "@nestjs/schedule";
import { DpomModule } from "./dpom/nike-dpom.module";
import { SupplierModule } from "./supplier/supplier.module";
import { DataSource } from "typeorm";
import {
  AppDataSource,
  AppDataSource1,
  AppDataSource2,
} from "./app-datasource";
import { EmployeeModule } from "./vrs/masters/employee/employee.module";
import { VehiclereqModule } from "./vrs/masters/vehicle-request/vehicle-req-module";
import { DepartmentModule } from "./vrs/masters/department/department.module";
import { VehicleModule } from "./vrs/masters/vehicle/vehicle.module";
import { VehicleIssueModule } from "./vrs/masters/vehicle-issue/vehicle-issue-module";
import { DriverModule } from "./vrs/masters/drivers/driver.module";
import { VendorModule } from "./vrs/masters/vendor/vendor.module";
import { BudgetModule } from "./vrs/masters/budget/budget.module";
import { RoleModule } from "./vrs/masters/roles/role-module";
import { RootWiseCostModule } from "./vrs/masters/root-wise-cost/root-wise-cost.module";
import { LocationModule } from "./vrs/masters/location/location.module";
import { LocationsModule } from "./vrs/masters/locations/locations.module";
import { VehicleCategoryModule } from "./vrs/masters/vehicle-category/vehicle-category.module";
import { VehicleModelModule } from "./vrs/masters/vehicle-model/vehicle-model-module";
import { DivisionModule } from "./vrs/masters/division/division-module";

@Module({
  imports: [
    ScheduleModule.forRoot(),
    TypeOrmModule.forRoot({
      type: "mysql",
      timezone: "Z",
      host: appConfig.database.host,
      port: appConfig.database.port,
      username: appConfig.database.username,
      password: appConfig.database.password,
      database: appConfig.database.dbName,
      autoLoadEntities: true,
      synchronize: false,
      logging: true,
      extra: {
        connectionLimit: 20,
      },
    }),
    VehiclereqModule,
    EmployeeModule,
    DepartmentModule,
    VehicleModule,
    VehicleIssueModule,
    DriverModule,
    VendorModule,
    BudgetModule,
    RoleModule,
    RootWiseCostModule,LocationsModule,VehicleCategoryModule,VehicleModelModule,DivisionModule
  ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule {}
